module.exports = __webpack_public_path__ + "img/venmo.3710473b.svg";